jQuery(function($) {
if ($.fn.slick) {
    $('.slider__active').slick({
        autoplay: true,
        autoplaySpeed: 2000,
        speed: 800,
        dots: false,
        arrows: false,
        infinite: true,
        centerMode: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        variableWidth: false
    });
}

if (typeof gsap !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);

    function initParallax() {
        const wrappers = document.querySelectorAll('.parallax-wrapper');

        wrappers.forEach((wrapper, i) => {
            const image = wrapper.querySelector('.parallax-image');
            const content = wrapper.querySelector('.p-feature__cont__content');
            const textBlocks = wrapper.querySelectorAll('.text-block');

            const updateLayout = () => {
                if (!image || !content) return;
                const imgHeight = image.offsetHeight;
                if (imgHeight > 0) {
                    gsap.set(content, { marginTop: -imgHeight });
                    ScrollTrigger.refresh();
                }
            };

            // 初期実行と画像読み込み待機
            updateLayout();
            const imgElement = image.querySelector('img');
            if (imgElement) {
                if (imgElement.complete) {
                    updateLayout();
                } else {
                    imgElement.addEventListener('load', updateLayout);
                }
            }

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: wrapper,
                    start: 'top top',
                    end: () => `+=${image.offsetHeight}`,
                    scrub: true,
                    pin: true,
                    pinSpacing: true,
                    invalidateOnRefresh: true,
                    anticipatePin: 1,
                    refreshPriority: wrappers.length - i, // 順番通りに計算
                    onRefresh: updateLayout
                }
            });

            tl.fromTo(content,
                { y: () => image.offsetHeight },
                { y: 0, ease: 'none', lazy: false }
            );

            textBlocks.forEach((block, index) => {
                gsap.to(block, {
                    opacity: 1,
                    y: 0,
                    duration: 0.8,
                    delay: index * 0.1,
                    scrollTrigger: {
                        trigger: block,
                        start: 'top 85%',
                        toggleActions: 'play none none none'
                    }
                });
            });
        });

        // リサイズ時のリフレッシュを安定させる
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                ScrollTrigger.refresh();
            }, 250);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initParallax);
    } else {
        initParallax();
    }

    window.addEventListener('load', () => {
        ScrollTrigger.refresh();
    });

    const isIpad = /iPad|Macintosh/.test(navigator.userAgent)
                   && navigator.maxTouchPoints > 1;

    window.addEventListener("orientationchange", () => {
        if (isIpad && (window.orientation === 90 || window.orientation === -90)) {
            setTimeout(() => {
                ScrollTrigger.refresh();
            }, 300);
        }
    });
}

document.addEventListener('DOMContentLoaded', function () {
    const cross = document.querySelector('.c-cross');
    const header = document.querySelector('header');
    const fv = document.querySelector('.p-fv.l-fv');

    if (cross && header && fv) {
        cross.addEventListener('click', function (e) {
            e.preventDefault();
            header.classList.add('is-hidden');
            fv.classList.add('no-padding');
        });

        cross.addEventListener('touchend', function (e) {
            e.preventDefault();
            header.classList.add('is-hidden');
            fv.classList.add('no-padding');
        });
    }
});

let isHover = false;
let isPointerDown = false;

function updateFeatureBox() {
    if (isHover || isPointerDown) {
        $('.p-feature__cont_user_box').stop(true, true).fadeOut(300);
    } else {
        $('.p-feature__cont_user_box').stop(true, true).fadeIn(300);
    }
}

$('.slider')
    .on('mouseenter', function () {
        isHover = true;
        updateFeatureBox();
    })
    .on('mouseleave', function () {
        isHover = false;
        updateFeatureBox();
    });

$('.slider').on('mousedown', function () {
    isPointerDown = true;
    updateFeatureBox();
}).on('mouseup', function () {
    isPointerDown = false;
    updateFeatureBox();
});
document.querySelectorAll('.slider').forEach(function (el) {
    el.addEventListener('touchstart', function () {
        isPointerDown = true;
        updateFeatureBox();
    }, { passive: true });
    el.addEventListener('touchend', function () {
        isPointerDown = false;
        updateFeatureBox();
    }, { passive: true });
    el.addEventListener('touchcancel', function () {
        isPointerDown = false;
        updateFeatureBox();
    }, { passive: true });
});

});

// ショップからの返信 アコーディオン（Judge.me）
function initJdgmReplyAccordion(reply) {
  if (reply.dataset.accordionInit) return;
  reply.dataset.accordionInit = '1';

  const header = document.createElement('div');
  header.className = 'jdgm-rev__reply-accordion-header';
  header.innerHTML = '<span>ショップからの返信</span><span class="jdgm-rev__reply-accordion-icon"></span>';

  const body = document.createElement('div');
  body.className = 'jdgm-rev__reply-accordion-body';
  body.style.height = '0';

  while (reply.firstChild) {
    body.appendChild(reply.firstChild);
  }
  if (!body.textContent.trim()) {
    reply.style.display = 'none';
    return;
  }
  reply.appendChild(header);
  reply.appendChild(body);

  header.addEventListener('click', function () {
    const isOpen = reply.classList.toggle('is-open');
    if (isOpen) {
      body.style.height = body.scrollHeight + 'px';
      body.addEventListener('transitionend', function handler() {
        if (reply.classList.contains('is-open')) body.style.height = 'auto';
        body.removeEventListener('transitionend', handler);
      }, { once: true });
    } else {
      body.style.height = body.scrollHeight + 'px';
      body.offsetHeight;
      body.style.height = '0';
    }
  });
}

(function () {
  function initAllReplies() {
    document.querySelectorAll('.jdgm-rev__reply').forEach(initJdgmReplyAccordion);
  }
  const observer = new MutationObserver(initAllReplies);
  observer.observe(document.body, { childList: true, subtree: true });
  initAllReplies();
})();

document.addEventListener('DOMContentLoaded', function () {
  // Subcategory Accordion Logic
  const subToggles = document.querySelectorAll('.category-item__toggle');
  if (subToggles.length > 0) {
    subToggles.forEach(button => {
      button.addEventListener('click', () => {
        const parentItem = button.closest('.category-item');
        const subList = parentItem.querySelector('.subcategory-list');

        // 他のアコーディオンを閉じたい場合はここでループ処理を入れる

        const isOpen = parentItem.classList.toggle('is-open');
        button.setAttribute('aria-expanded', isOpen);

        if (isOpen) {
          subList.style.height = subList.scrollHeight + 'px';
          subList.addEventListener('transitionend', function handler() {
            subList.style.height = 'auto';
            subList.removeEventListener('transitionend', handler);
          }, { once: true });
        } else {
          subList.style.height = subList.scrollHeight + 'px';
          requestAnimationFrame(function () {
            subList.style.height = '0';
          });
        }
      });
    });
  }

  // Top-level Category Accordion Logic
  const accordion = document.querySelector('details.category-accordion');
  if (accordion) {
    const summary = accordion.querySelector('.category-accordion__header');
    const content = accordion.querySelector('.category-accordion__content');

    if (summary && content) {
      summary.addEventListener('click', function(e) {
        e.preventDefault();
        if (accordion.open) {
          content.style.height = content.scrollHeight + 'px';
          requestAnimationFrame(function() {
            content.style.height = '0';
            content.addEventListener('transitionend', function handler() {
              accordion.removeAttribute('open');
              content.style.height = '';
              content.removeEventListener('transitionend', handler);
            }, { once: true });
          });
        } else {
          accordion.setAttribute('open', '');
          content.style.height = '0';
          requestAnimationFrame(function() {
            content.style.height = content.scrollHeight + 'px';
            content.addEventListener('transitionend', function handler() {
              content.style.height = 'auto';
              content.removeEventListener('transitionend', handler);
            }, { once: true });
          });
        }
      });
    }
  }
});

// Floating Cart Button Logic
document.addEventListener('DOMContentLoaded', () => {
  const floatingCartBtn = document.getElementById('custom-floating-cart-btn');
  if (floatingCartBtn) {
    floatingCartBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const originalCartIcon = document.getElementById('cart-icon-bubble');
      if (originalCartIcon) {
        originalCartIcon.click();
      } else {
        window.location.href = floatingCartBtn.href;
      }
    });
  }
});
